<template>
<div>
  <div class="section-block">
    <font-awesome-icon icon="list-ol" class="fa-fw" />Stand
  </div>

<table id="ranking" class="table table-sm">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">we</th>
          <th scope="col">wi</th>
          <th scope="col">ve</th>
          <th scope="col">ds</th>
          <th scope="col">p</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in data" :key="item.rank">
            <th scope="row">{{ item.rank }}</th>
            <td class="text-left">{{ item.name }}</td>
            <td>{{ item.games }}</td>
            <td>{{ item.wins }}</td>
            <td>{{ item.losses }}</td>
            <td>{{ item.goals - item.goalsAgainst }}</td>
            <td>{{ item.points }}</td>
          </tr>
        </tbody>
      </table>
  </div>
</template>

<script>
export default {
  name: 'Ranking',
  props: {
    data: Array
  }
}
</script>

<style scoped>
#ranking 
{
  text-align: right
}
</style>
